module.exports = __webpack_public_path__ + "img/paul-sab.1ac9c251.jpg";